import { render, staticRenderFns } from "./WPBaseSwitch.vue?vue&type=template&id=09beef46"
import script from "./WPBaseSwitch.vue?vue&type=script&lang=ts"
export * from "./WPBaseSwitch.vue?vue&type=script&lang=ts"
import style0 from "./WPBaseSwitch.vue?vue&type=style&index=0&id=09beef46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports